module.exports = __webpack_public_path__ + "static/img/point-color@t.d6a2619.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/partecs/point-color@t.png
// module id = 8Px0
// module chunks = 0